<template>
    <div class="flexible-space-wrapper">
        <component
            v-for="component in getActiveComponents(
                'CategoryPage',
                'C',
                dynamicComponents
            )"
            :key="component.name"
            :is="component.name"
            v-bind="component.props"
        />
    </div>
</template>

<script>
import { flexibleSpaceMixin, partnersMixin } from '@/mixins';
import { FLEXIBLE_COMPONENTS } from '@/constants';
const { PARTNER_PODIUM, SUMMARY, PARTNER_CARD_CAROUSEL } = FLEXIBLE_COMPONENTS;

export default {
    name: 'FlexibleSpaceC',
    components: {
        [PARTNER_PODIUM]: () =>
            import('@molecules/PartnerPodium/PartnerPodium'),
        [PARTNER_CARD_CAROUSEL]: () =>
            import('@molecules/PartnerCardCarousel/PartnerCardCarousel'),
        [SUMMARY]: () => import('@organisms/Summary/SummaryContainer'),
    },
    data: () => ({
        page: 'CategoryPage',
        spaceArea: 'C',
    }),
    mixins: [partnersMixin, flexibleSpaceMixin],
    computed: {
        dynamicComponents() {
            return {
                [SUMMARY]: {
                    shouldShow: true,
                    props: {},
                },
                [PARTNER_PODIUM]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                    props: {
                        ...this.$globalConstants.components[PARTNER_PODIUM],
                        partners: this.podiumPartners,
                    },
                },
                [PARTNER_CARD_CAROUSEL]: {
                    shouldShow: this.$globalConstants.host['use_carousel'],
                    props: {
                        ...this.$globalConstants.components[
                            PARTNER_CARD_CAROUSEL
                        ],
                        partners: this.activeOnlyPartners,
                    },
                },
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.flexible-space-wrapper {
    width: 100%;
}
</style>
